module.exports = __webpack_public_path__ + "img/profile_bg.9c14a3a7.png";